import { CircleX } from 'lucide-react';
import { isRouteErrorResponse, useParams, useRouteError, useRouteLoaderData } from 'react-router';
import type { ClubDetail } from '@repo/shared-types';
import { urlHome } from '@/urls';
import { StatusPage } from '@/components/common/status-page';
import { SubscriptionExpired } from '@/components/config/subscription-access';
import { IS_DEV } from '@/data/constants';
import { id as appLayoutId } from '@/layout/app-layout';
import { cashierLayoutId } from '@/route-ids';

export function ErrorBoundary() {
  const { message, code } = useRouteError() as { message: string; code?: string };

  return (
    <StatusPage
      title="Algo no cargó"
      description={
        IS_DEV
          ? `${message} ${code ?? ''}`
          : 'No pudimos abrir esta página. Vuelve al inicio e intenta de nuevo.'
      }
      actions={[{ label: 'Volver al inicio', url: urlHome() }]}
      icon={CircleX}
      color="red"
    />
  );
}

type ClubLayoutData = { club: ClubDetail } | undefined;

/**
 * Inside a club's layouts: the API answers 402 to its management while the club
 * has no access, and the screen says so inside the layout. Any other error goes
 * up to the root boundary, as before.
 */
export function ClubErrorBoundary() {
  const error = useRouteError();
  const { id } = useParams();
  const app = useRouteLoaderData(appLayoutId) as ClubLayoutData;
  const cashier = useRouteLoaderData(cashierLayoutId) as ClubLayoutData;

  if (!isRouteErrorResponse(error) || error.status !== 402) throw error;
  return <SubscriptionExpired club={(app ?? cashier)?.club} clubId={id!} />;
}
